
import events, { ConfirmCallback } from "@/events";
import { defineComponent, ref } from "vue";
import { useI18n } from "vue-i18n";
import TextInput from "@/components/TextInput.vue";
import "@/assets/scss/dialog.scss";

export default defineComponent({
    components: { TextInput },
    setup() {
        const { t } = useI18n({ useScope: 'global' });
        const visible = ref(false);
        const title = ref('');
        const text = ref('');
        const callback = ref<ConfirmCallback>(() => false)
        const input = ref('');
        const takeInput = ref(false);

        events.on('dialog:show', event => {
            visible.value = true;
            title.value = event.title;
            text.value = event.text;
            callback.value = event.callback;
            takeInput.value = event.input !== undefined;
            input.value = '';
        });

        return {
            t,
            visible, title, text,
            input, takeInput,
            submit(confirm: boolean) {
                visible.value = false;
                if (takeInput.value && confirm) {
                    callback.value(confirm, input.value);
                } else callback.value(confirm);
            }
        }
    }
})

